<script setup lang="ts">
import { useCart } from "@shopware-pwa/composables-next";
import { Divider } from "~/components/clarity-ui/Divider";
import { Heading } from "~/components/clarity-ui/Heading";
import { Tint } from "~/components/clarity-ui/Tint";
import CommonLabel from "~/templates/components/CommonLabel.vue";
import SharedPrice from "~/templates/components/shop/shared/SharedPrice.vue";
import { getPromotiontLineItems } from "~/utils/helper/shop/cart";

const { cart, cartItems, removeItem, subtotal, shippingTotal, totalPrice } = useCart();

const promoLineItems = computed(() => getPromotiontLineItems(cartItems.value ?? []));

// has promo extension ???
const subTotalWithoutPromotion = computed(
  () => cart?.value?.extensions?.priceWithoutPromotion?.price ?? subtotal.value ?? 0,
);
</script>

<template>
  <div>
    <div
      class="grid grid-cols-[2fr_1fr] gap-2 rounded-lg text-sm xl:bg-light-grey xl:p-8 xl:text-base"
    >
      <Heading class="col-span-2 mb-4" size="medium" tag="h2">
        <CommonLabel path="BWF/shop/checkout/cart/summary" />
      </Heading>

      <CommonLabel path="BWF/shop/checkout/cart/subtotal" />
      <SharedPrice
        :value="subTotalWithoutPromotion"
        class="place-self-end font-medium"
        has-asterisk
      />

      <template v-for="promoLineItem in promoLineItems" :key="promoLineItem.id">
        <p>
          <CommonLabel path="BWF/shop/checkout/cart/voucher" />
          <span class="break-all">&nbsp;{{ promoLineItem.payload?.code }}</span>
        </p>

        <div class="flex flex-col items-end">
          <SharedPrice
            :value="`-${promoLineItem.extensions?.promotionDetails?.absoluteDiscount ?? 0}`"
            class="font-medium"
            discounted
          />
          <button
            class="text-link text-right text-black"
            type="button"
            @click="removeItem(promoLineItem)"
          >
            <CommonLabel class="mb-2 block text-xs" path="BWF/shop/checkout/cart/removeVoucher" />
          </button>
        </div>
      </template>

      <CommonLabel path="BWF/shop/checkout/cart/shippingCosts" />
      <SharedPrice class="place-self-end font-medium" :value="shippingTotal" has-asterisk />

      <Divider class="col-span-full my-4" />

      <CommonLabel class="font-medium" path="BWF/shop/checkout/cart/total" />
      <SharedPrice class="place-self-end font-medium" :value="totalPrice" />

      <Tint class="col-span-full text-xs" tag="div">
        <CommonLabel path="BWF/shop/checkout/plusTax" />
      </Tint>

      <Divider class="col-span-full my-4" />

      <CheckoutPromotionCode class="col-span-full" />
    </div>
  </div>
</template>
